import { createSlice } from "@reduxjs/toolkit";
import { IChatMessage } from "../types";

interface IConversationState {
  chatMessages: IChatMessage[];
  modelContext: "presets" | "custom";
  conversationStyle: "creative" | "balanced" | "precise";
  tokenCount: number;
  isChatResponseInProgress: boolean;
  sessionID: string;
  inSessionFiles: any[];
  inSessionFileUploadProgress: boolean;
  inSessionSignedUrlPath: string;
}

const initialState: IConversationState = {
  chatMessages: [] as IChatMessage[],
  modelContext: "presets",
  conversationStyle: "balanced",
  tokenCount: 0,
  isChatResponseInProgress: false,
  sessionID: "",
  inSessionFiles: [],
  inSessionFileUploadProgress: false,
  inSessionSignedUrlPath: ""
};

const conversationSlice = createSlice({
  name: "conversation",
  initialState,
  reducers: {
    setChatMessages(state, action) {
      state.chatMessages = action.payload;
    },
    setModelContext(state, action) {
      state.modelContext = action.payload;
    },
    setConversationStyle(state, action) {
      state.conversationStyle = action.payload;
    },
    setTokenCount(state, action) {
      state.tokenCount = action.payload;
    },
    setIsChatResponseInProgress(state, action) {
      state.isChatResponseInProgress = action.payload;
    },
    setSessionID(state, action) {
      state.sessionID = action.payload;
    },
    setInSessionFiles(state, action) {
      state.inSessionFiles.push(action.payload);
    },
    removeInSessionFiles(state, action) {
      state.inSessionFiles = state.inSessionFiles.filter((item) => item.uid !== action.payload.uid);
    },
    removeInSessionAllFiles(state) {
      state.inSessionFiles = [];
    },
    updateInSessionFileStatus(state, action) {
      const { status, is_indexed, filterBy } = action.payload;
      state.inSessionFiles = state.inSessionFiles.map(file => {
        if (filterBy && filterBy.is_indexed !== undefined) {
          if (file.is_indexed === filterBy.is_indexed) {
            const updatedFile = { ...file, status: status };
            if (is_indexed !== undefined) {
              updatedFile.is_indexed = is_indexed;
            }
            return updatedFile;
          }
        } else {
          const updatedFile = { ...file, status: status };
          if (is_indexed !== undefined) {
            updatedFile.is_indexed = is_indexed;
          }
          return updatedFile;
        }
        return file;
      });
    },
    updateInSessionFileStatusByName(state, action) {
      const { filename, status, is_indexed } = action.payload;
      state.inSessionFiles = state.inSessionFiles.map(file => {
        if (file.name === filename || file.uid === filename) {
          const updatedFile = { ...file, status: status };
          if (is_indexed !== undefined) {
            updatedFile.is_indexed = is_indexed;
          }
          return updatedFile;
        }
        return file;
      });
    },
    setInSessionFileUploadProgress(state, action) {
      state.inSessionFileUploadProgress = action.payload;
    },
    setInSessionSignedUrlPath(state, action) {
      state.inSessionSignedUrlPath = action.payload;
    },
    resetConversationState() {
      return initialState;
    }
  },
});

export const {
  setChatMessages,
  setModelContext,
  setConversationStyle,
  setTokenCount,
  setIsChatResponseInProgress,
  setSessionID,
  setInSessionFiles,
  removeInSessionFiles,
  setInSessionFileUploadProgress,
  setInSessionSignedUrlPath,
  resetConversationState,
  removeInSessionAllFiles,
  updateInSessionFileStatus,
  updateInSessionFileStatusByName
} = conversationSlice.actions;
export default conversationSlice.reducer;
